import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, Typography, Box, Popover } from '@mui/material'
import close from 'images/close.svg'

const PriceChangesPopOver = ({
    popOverData,
    priceChangeAnchor = false,
    priceChangeTransformOrigin = {},
    priceChangeAnchorClose = () => {},
    isTotalPopOver = false
}) => {
    const open = Boolean(priceChangeAnchor)
    const id = open ? 'price-changes-popover' : undefined
    return (
        <Box>
            <Popover
                id={id}
                open={open}
                sx={{
                    zIndex: 3100,
                    '.MuiPopover-paper': {
                        borderRadius: 2,
                        width: 'max-content',
                        maxWidth: isTotalPopOver ? { xs: 185, sm: 198, md: 354 } : { xs: 185, sm: 190, md: 300 },
                        border: '1px solid #6B7786',
                        backgroundColor: 'background.default',
                        padding: '10px 25px 10px 8px',
                        margin: '11px 0px',
                        gap: '16px',
                        boxShadow: 'none',
                        ml: isTotalPopOver ? { xs: 'initial', md: '-150px' } : { xs: 'initial', md: '-50px' }
                    }
                }}
                anchorEl={priceChangeAnchor}
                onClose={priceChangeAnchorClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                data-testid="popover-content"
            >
                <Typography sx={{ margin: '5px', color: 'common.charcoal.main', typography: 'boldBody1' }}>
                    {popOverData.title}
                </Typography>

                <Typography sx={{ margin: '5px', color: 'common.charcoal.main', typography: 'regularBody1' }}>
                    {popOverData.desc}
                </Typography>
                <IconButton
                    aria-label="close"
                    tabIndex={0}
                    onClick={priceChangeAnchorClose}
                    sx={{
                        color: 'common.charcoal.main',
                        padding: '8px 5px',
                        position: 'absolute',
                        right: 0,
                        top: 0
                    }}
                    data-testid="popover-close-button"
                >
                    <img src={close} alt={'close modal'} width={24} height={24} />
                </IconButton>
            </Popover>
        </Box>
    )
}

PriceChangesPopOver.propTypes = {
    popOverData: PropTypes.object,
    priceChangeTransformOrigin: PropTypes.object,
    priceChangeAnchorClose: PropTypes.func,
    isTotalPopOver: PropTypes.bool
}

export default PriceChangesPopOver
